module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-1c17cb8cea24aff690dc82c88224fc03.jpg";